<template lang="pug">
    .container.mx-auto(:class="[spacingTop, spacingBottom, oddRows]")
        .table
          Row(
            v-for="( row, i ) in table"
            :key="row.id"
            :index="i"
            :cols="row"
        )
</template>

<script>
//import AOS from 'aos';
import { get, cloneDeep } from '@/helpers';
import Row from './row';

export default {
    name: 'Table',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        Row
    },
    computed: {
        table() {
            let table = this.section.contents || [];
            return cloneDeep(table).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
        },
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },
        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },
        oddRows() {
            let oddRows = 'design-base';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'oddRows');
                if (setting && setting.value !== undefined) oddRows = setting.value;
            }
            return oddRows;
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"
.table
  @apply table w-full

.design-odd
  .table_row:nth-child(odd)
    @apply bg-gray-100
</style>
